import { report_route_targetService } from '../_services';

const state = { onRequest: false, report_route_target: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        report_route_targetService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  report_route_target: state => {
    return state.report_route_target
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.report_route_target = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.report_route_target = data;
    },
    clear_data(state) {
      state.onRequest = false;
      state.report_route_target = [];
    },
    error(state) {
        state.onRequest = false;
    },
};

export const report_route_targets = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
